<div (onDropSuccess)="dropped($event.dragData)" *ngIf="droppable" [dropZones]="dropZones"
     class="drop-container" dnd-droppable>
    <div class="drop-container-heading">
        <div *ngIf="icon" class="drop-container-heading-icon">
            <fui-icon [height]="18" [icon]="icon" [width]="15"></fui-icon>
        </div>
        <div class="drop-container-heading-text">
            {{title | translate}}
        </div>
    </div>
    <div class="drop-container-dropped-content">
        <ng-content></ng-content>
    </div>
    <div (onDropSuccess)="dropped($event.dragData)" *ngIf="showDropArea" [dropZones]="dropZones"
         class="drop-container-drop-area"
         dnd-droppable>
        {{dropAreaLabel | translate}}
    </div>

    <div *ngIf="message" class="drop-container-message"> {{message}}</div>
</div>

